import { render, staticRenderFns } from "./questionget.vue?vue&type=template&id=baa8bf40&scoped=true&"
import script from "./questionget.vue?vue&type=script&lang=js&"
export * from "./questionget.vue?vue&type=script&lang=js&"
import style0 from "./questionget.vue?vue&type=style&index=0&id=baa8bf40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa8bf40",
  null
  
)

export default component.exports